"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Default = _interopRequireDefault(require("./Variants/Default"));

var _Rectangle = _interopRequireDefault(require("./Variants/Rectangle"));

var _jsxRuntime = require("react/jsx-runtime");

var LoginButtons = function LoginButtons(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      customState = _ref.customState,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [variant === 'default' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Default.default, {
      onClick: onClick,
      customState: customState
    }), variant === 'rectangle' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Rectangle.default, {
      onClick: onClick,
      customState: customState
    })]
  });
};

var _default = LoginButtons;
exports.default = _default;